export enum QuickApplyStep {
    ContactInfo,
    PersonalInfo,
    TextDescription,
    Success,
}
